var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unsubscribe"},[_c('h1',[_c('span',{directives:[{name:"t",rawName:"v-t",value:('unsubscribe.invalidParams'),expression:"'unsubscribe.invalidParams'"}]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }